const BlogSearch = {
  // Token liberado somente para o endpoint /api/collections/get/posts
  Token: '1f67b2941385137ce577fb4014ab4d',
  baseURLApi: `${window.location.origin}/admin/conteudo`,
  baseList: document.querySelector('[data-posts-list]'),
  initialPosts: '',
  searchParam: '',

  // ====================================================== //
  // ================ Faz o fetch dos posts =============== //
  // ====================================================== //
  api(search) {
    const _this = this;

    fetch(`${_this.baseURLApi}/api/collections/get/posts`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Cockpit-Token': `${_this.Token}`,
      },
      body: JSON.stringify({
        filter: {
          publish: true,
          // Pode usar $and
          $or: [
            // $options faz com que a filtragem não seja case sensitive
            { content: { $regex: `${search}`, $options: 'i' } },
            { title: { $regex: `${search}`, $options: 'i' } },
            // { description: { $regex: `${search}`, $options: 'i' } },
          ],
        },
        sort: { _o: -1 },
        populate: 1,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        // Lista os posts
        _this.listPosts(res.entries);

        // Seta o spinner de loading como false e remove o spinner
        _this.setIsLoading(true);

        // Scroll para o topo da página
        _this.scrollToTop();
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
        // Seta o spinner de loading como false e remove o spinner
        _this.setIsLoading(false);
      });
  },

  // ================================================================== //
  //  Responsável por guardar os posts iniciais ao carregar a página    //
  // ================================================================== //
  maintainActualPosts() {
    const _this = this;
    const Posts = document.querySelector('[data-posts-list]').innerHTML;

    // Guarda os posts iniciais
    _this.initialPosts = Posts;
  },

  // ====================================================== //
  //  Função para atrasar a busca, executa ao término do timer  //
  // ====================================================== //
  debounce(cb, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  },

  // ====================================================== //
  //  Faz com que o scroll volte para o topo da página após a busca  //
  // ====================================================== //
  scrollToTop() {
    // A ancora do scroll é um span com o atributo data-anchor
    document.querySelector('[data-anchor]').scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  },

  // ====================================================== //
  // == Ajusta a data dos posts para o formato brasileiro = //
  // ====================================================== //
  dateAdjust(date) {
    const _this = this;
    const dateAdjust = date.split('-').reverse().join('.');
    return dateAdjust;
  },

  // ====================================================== //
  // ========= Seta o spinner de loading no input ========= //
  // ====================================================== //
  setIsLoading(boolean) {
    let spinner = document.querySelector('[data-search-spinner]');
    boolean == true ? spinner.classList.add('-visible') : spinner.classList.remove('-visible');
  },

  // ====================================================== //
  // ============= Monta o template dos posts ============= //
  // ====================================================== //
  formatarData(dataString) {
    const data = new Date(dataString);
  
    const meses = [
      "JANEIRO", "FEVEREIRO", "MARÇO", "ABRIL", "MAIO", "JUNHO",
      "JULHO", "AGOSTO", "SETEMBRO", "OUTUBRO", "NOVEMBRO", "DEZEMBRO"
    ];
  
    const nomeMes = meses[data.getMonth()];
    const ano = data.getFullYear();
  
    const dataFormatada = `${data.getDate()} ${nomeMes}, ${ano}`;
  
    return dataFormatada;
  },
  
  templatePost(post) {
    const _this = this;

    var permalink = post.title.toLowerCase();
    permalink = permalink.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    permalink = permalink.replace(/[^a-zA-Z0-9]/g, ' ');
    permalink = permalink.replace(/\s\s+/g, ' ');
    permalink = permalink.trim();
    permalink = permalink.replaceAll(' ', '-');  

    const image = post.thumb.path
      ? `<div class="image">
          <a href="${window.location.origin}/m/blog/${post._id}/${permalink}">
            <figure class="banner-inner">
              <div class="image img-el">
                <div class="lazyload-container">
                  <img alt="${post.title}" class="img-fluid" src="${post.thumb.path}"/>
                </div>
              </div>
            </figure>
          </a>
        </div> `
      : 
      `<div class="image">
        <a href="${window.location.origin}/m/blog/${post._id}/${permalink}">
          <figure class="banner-inner">
            <div class="image img-el">
              <div class="lazyload-container">
                <img alt="${post.title}" class="img-fluid" src="https://via.placeholder.com/356x213""/>
              </div>
            </div>
          </figure>
        </a>
      </div> `;

    return `
      <div class="post">
        ${image}
        <div class="text-wrapper">
          <div class="text">
            <a href="${window.location.origin}/m/blog/${post._id}/${permalink}">
              ${post.title}
            </a>
          </div>
          <div class="post-footer">
            <span> ${this.formatarData(post.date)} </span>
            <span>${post.categories[0]}</span>
          </div>
      </div>
    `;
  },

  // ====================================================== //
  // =========== Lista os posts seção setada ============== //
  // ====================================================== //
  listPosts(Posts) {
    const _this = this;

    // Limpa a lista
    document.querySelector('[data-posts-list]').innerHTML = '';

    // document.createDocumentFragment agrupa os elementos para serem inseridos de uma única vez
    // Evita que o DOM seja atualizado a cada novo elemento
    const fragmentDOM = document.createDocumentFragment();

    if (Posts.length > 0) {
      Posts.forEach((post) => {
        const template = _this.templatePost(post);
        fragmentDOM.appendChild(document.createRange().createContextualFragment(template));
      });

      // Insere o fragmento no DOM
      document.querySelector('[data-posts-list]').appendChild(fragmentDOM);

      // Atualiza o lazyload
      window.lazyLoadInstance.update();
    } else {
      document.querySelector('[data-posts-list]').innerHTML = `<span></span><span class="results-not-found"> A sua pesquisa por "${_this.searchParam}" não teve resultados :(</span><span></span>`;
    }

    document.querySelector('.pagination-wrapper').style.display = 'none';
  },

  // ====================================================== //
  //  Responsável por pegar o valor do input e ajustar a regex da busca  //
  // ====================================================== //
  searchRegex(value) {
    // Remove os espaços em branco do início e do fim e adiciona o pipe (|)
    // Monta a regex da seguinte forma, ex: (palavra1|palavra2|palavra3)

    let regex = `(${value.replace(/( )+/g, '|')})`;

    // Trata a regex da busca
    if (regex.charAt(regex.length - 2) == '|') {
      // remove o ultimo caracter
      regex = regex.replace('|', '');
    }
    // console.log('REGEX', regex);
    this.api(regex);
  },

  // ====================================================== //
  // =========== FAZ A BUSCA COM O DEBOUNCE ============== //
  // ====================================================== //
  search() {
    const _this = this;
    const search = document.getElementById('searchBlog');

    // Listener com o debounce com delay de 1000ms para evitar o carregamento excessivo de requisições
    search.addEventListener(
      'input',
      this.debounce((e) => {
        if (e.target.value !== '') {
          // Seta o loading do input para o usuário saber que está sendo feito uma busca
          _this.setIsLoading(true);

          // Mostra os posts de acordo com o que o usuário digitou
          _this.searchRegex(e.target.value);
          _this.searchParam = e.target.value;
        } else {
          // Se o campo estiver vazio, mostra os posts iniciais
          document.querySelector('[data-posts-list]').innerHTML = _this.initialPosts;
          document.querySelector('.pagination-wrapper').style.display = 'block';

          window.lazyLoadInstance.update();
        }
      }, 1000)
    );
  },

  init() {
    // Pega os posts iniciais
    this.search();

    window.onload = () => {
      this.maintainActualPosts();
    };
  },
};

window.addEventListener('DOMContentLoaded', () => {
  BlogSearch.init();
});
